
/*
 * config Variables
 */
require('./_config.js');


/*
 * loading
 */
require('./_load.js');


/*
 * navigation menu
 */
require('./_nav.js');


/*
 * scroll fadein
 */
require('./_scroll.js');


/*
 * scroll keyvisual
 */
require('./_keyvisual.js');


/*
 * anchor link
 */
require('./_anchor.js');


/*
 * slider
 */
require('./_slider.js');


/*
 * accordion
 */
require('./_accordion.js');


/*
 * popup modal
 */
require('./_modal.js');


/*
 * TOPへ戻るボタン
 */
require('./_to-top.js');


/*
 * character section
 */
require('./_character.js');


/*
 * mechanical section
 */
require('./_mechanical.js');


/*
 * story section
 */
require('./_story.js');


/*
 * fixed banner (ticket / theater)
 */
require('./_fixed-banner.js');


/*
 * news category filter
 */
